import {call, put, takeLatest} from 'redux-saga/effects';
import {notification} from 'antd';
import ApiRouts from '../../api/routes';
import {FETCH_PRODUCT_LIST, INITIALIZE, SET_SIGN_IN, SET_SIGN_UP, SIGN_IN_SUCCESS, SIGN_UP_SUCCESS,} from "../actions";
import {POST} from '../../api';
import {setSignInErrorMessage} from '../slices/signInErrorMessage';
import {setSignUpErrorMessage} from "../slices/signUpErrorMessage";
import {SIGN_IN, SIGN_UP} from "../actions";
import {setIsLoginModalOpen} from "../slices/isLoginModalOpenSlice";
import { getProfile } from '../Profile/action';


export function* SignIn(action) {

    try {
        const response = yield call(POST, `${ApiRouts.API_SIGN_IN}`, action.payload);

        if (response) {

            localStorage.setItem('edexLicenceToken', response.data.token);


            notification.success({
                message: 'Sign in Successful',
                description: 'You have signed in successfully!',
                placement: 'topRight',
                // className: notificationClass,

            });
            
            yield put(setIsLoginModalOpen(false));
            yield put({type: FETCH_PRODUCT_LIST});
            yield put({type: SIGN_IN_SUCCESS, data: response.data});
            yield put(getProfile());



        } else {
            throw new Error('Failed to fetch the latest version');
        }
    } catch (error) {

        yield put(setSignInErrorMessage(error.response?.data.errors));

        notification.error({
            message: 'Signin Failed',
            description: error.response?.data?.message || 'Something went wrong!',
            placement: 'topRight',
            // className: notificationClass,
        });

    }
}

export function* SignUp(action) {

    try {
        const response = yield call(POST, `${ApiRouts.API_SIGN_UP}`, action.payload);

        if (response) {

            if (response.data.token) {
                localStorage.setItem('edexLicenceToken', response.data.token);
            }

            yield put({
                type: SET_SIGN_UP,
                payload: response.data.message
            });

            notification.success({
                message: 'Sign up Successful',
                description: 'You have signed up successfully!',
                placement: 'topRight',
            });

            yield put(setIsLoginModalOpen(false));
            yield put({type: SIGN_UP_SUCCESS, data: response.data});
            yield put(getProfile());


        } else {
            throw new Error('Failed to fetch the latest version');
        }
    } catch (error) {

        yield put(setSignUpErrorMessage(error.response?.data.errors));

        notification.error({
            message: 'Signup Failed',
            description: error.response?.data?.message || 'Something went wrong!',
            placement: 'topRight',
        });
    }
}

// Watcher Saga
function* authSaga() {
    yield takeLatest(SIGN_IN, SignIn);
    yield takeLatest(SIGN_UP, SignUp);
}

export default authSaga;
